import { formatError } from '~/classes/ErrorHandlers'

export const useFormatError = () => {
  return (error: any) => {
    try {
      const { captureException } = useTrackEvent()
      captureException(error?.value ?? error)
    } catch {
      // Nuxt context unavailable — skip capture
    }
    return formatError(error)
  }
}
